import React from 'react';
import { Shape } from '../../types/Shape';
import { useI18n } from '../../contexts/I18nContext';

export interface ContextMenuPanelProps {
  contextMenu: { x: number; y: number; shapeId: string };
  contextShape: Shape;
  overlayZIndex: number;
  onUpdate: (updates: Partial<Shape>) => void;
  onDelete: () => void;
  onClose: () => void;
}

export const ContextMenuPanel: React.FC<ContextMenuPanelProps> = ({
  contextMenu,
  contextShape,
  overlayZIndex,
  onUpdate,
  onDelete,
  onClose,
}) => {
  const { t } = useI18n();
  const isArrow = contextShape.type === 'arrow';
  const isNonArrow = contextShape.type !== 'arrow';

  return (
    <div
      style={{
        position: 'fixed',
        left: contextMenu.x,
        top: contextMenu.y,
        background: 'white',
        border: '1px solid #e5e7eb',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        padding: '12px',
        zIndex: overlayZIndex,
        minWidth: '200px'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {isNonArrow && (
        <>
          <div style={{ marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.background}</div>
          <input
            type="color"
            value={contextShape.fill || '#FFFFFF'}
            onChange={(e) => onUpdate({ fill: e.target.value })}
            style={{ width: '100%', height: '40px', border: 'none', cursor: 'pointer' }}
          />
          <div style={{ marginTop: '12px', marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.border}</div>
          <input
            type="color"
            value={contextShape.stroke || '#D1D5DB'}
            onChange={(e) => onUpdate({ stroke: e.target.value })}
            style={{ width: '100%', height: '40px', border: 'none', cursor: 'pointer' }}
          />
          <div style={{ marginTop: '12px', marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.thickness}</div>
          <input
            type="range"
            min="0"
            max="10"
            step="0.5"
            value={contextShape.strokeWidth || 1}
            onChange={(e) => onUpdate({ strokeWidth: parseFloat(e.target.value) })}
            style={{ width: '100%' }}
          />
          <div style={{ marginTop: '12px', marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.font}</div>
          <select
            value={contextShape.fontSize || 16}
            onChange={(e) => onUpdate({ fontSize: parseInt(e.target.value) })}
            style={{ width: '100%', padding: '8px', border: '1px solid #e5e7eb', borderRadius: '4px' }}
          >
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="16">16</option>
            <option value="18">18</option>
            <option value="20">20</option>
            <option value="24">24</option>
            <option value="28">28</option>
            <option value="32">32</option>
            <option value="36">36</option>
          </select>
          <div style={{ marginTop: '12px', marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.priority}</div>
          <input
            type="number"
            value={contextShape.order || 0}
            onChange={(e) => onUpdate({ order: parseInt(e.target.value) || 0 })}
            style={{ width: '100%', padding: '8px', border: '1px solid #e5e7eb', borderRadius: '4px' }}
          />
        </>
      )}
      {isArrow && (
        <>
          <div style={{ marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.color}</div>
          <input
            type="color"
            value={contextShape.stroke || '#1E40AF'}
            onChange={(e) => onUpdate({ stroke: e.target.value })}
            style={{ width: '100%', height: '40px', border: 'none', cursor: 'pointer' }}
          />
          <div style={{ marginTop: '12px', marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.thickness}</div>
          <input
            type="range"
            min="1"
            max="10"
            step="0.5"
            value={contextShape.strokeWidth || 2}
            onChange={(e) => onUpdate({ strokeWidth: parseFloat(e.target.value) })}
            style={{ width: '100%' }}
          />
          <div style={{ marginTop: '12px', marginBottom: '8px', fontSize: '12px', fontWeight: 'bold', color: '#6b7280' }}>{t.properties.priority}</div>
          <input
            type="number"
            value={contextShape.order || 0}
            onChange={(e) => onUpdate({ order: parseInt(e.target.value) || 0 })}
            style={{ width: '100%', padding: '8px', border: '1px solid #e5e7eb', borderRadius: '4px' }}
          />
        </>
      )}
      <div
        style={{
          marginTop: '12px',
          padding: '8px 16px',
          background: '#ef4444',
          color: 'white',
          borderRadius: '4px',
          cursor: 'pointer',
          textAlign: 'center',
          fontSize: '14px'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = '#dc2626'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#ef4444'}
        onClick={onDelete}
      >
        {t.contextMenu.delete}
      </div>
    </div>
  );
};

export default ContextMenuPanel;
